import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19808 22187"
    {...props}
  >
    <path
      d="M7298 13380c-1625 0-2947-1306-2947-2911s1322-2911 2947-2911c1626 0 2948 1306 2948 2911s-1322 2911-2948 2911zm3044-4805c-402-628-996-1124-1702-1405C7149 4116 3429-1421 0 338l4197 8328c-317 530-502 1145-502 1803 0 283 38 557 101 821-1785 2865-5157 8865-1844 10897l5436-8165c909-22 1734-378 2356-949 3416 22 10000-507 10064-4498h-9466z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
